import type { RouteObject } from 'react-router-dom'
import { Navigate, Outlet } from 'react-router-dom'

import { identityPaths } from '../../../shared/core'

const routes: RouteObject = {
  path: '/auth',
  lazy: async () => {
    const { PublicGuard, AuthenticationLayout } = await import('../../../features/authentication')
    return {
      Component: () => (
        <PublicGuard>
          <AuthenticationLayout>
            <Outlet />
          </AuthenticationLayout>
        </PublicGuard>
      )
    }
  },
  children: [
    {
      path: 'login',
      index: true,
      lazy: async () => {
        const { LoginPage } = await import('../../../features/authentication')
        return { Component: LoginPage }
      }
    },
    {
      // A common OIDC `redirect_uri`. The callback is redeemed by
      // `OidcAuthProvider` before the router ever renders, and it rewrites the
      // URL to the landing page — so reaching this route means a stray or
      // direct hit. Bounce rather than 404. (A hit with a live session never
      // gets here: `PublicGuard` on the parent sends it home first.)
      path: 'callback',
      element: <Navigate replace to={identityPaths.authentication.login} />
    },
    {
      path: 'account-recovery',
      lazy: async () => {
        const { AccountRecoveryPage } = await import('../../../features/authentication')
        return { Component: AccountRecoveryPage }
      }
    }
  ]
}

export default routes
